import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import styles from "../../content/pages/homepage.module.css";

export default function PositionButtonsNews({ onSelectPosition, selectedPosition, scrollToTop }) {
  const positionsFilters = ["ALL", "QB", "RB", "WR", "TE"];
  const currentSelectedIndex = positionsFilters.indexOf(selectedPosition);

  // const handleButtonClick = (index, position) => {
  //   setClickedButtonIndex(index);
  //   if (position === "DEF") {
  //     // Filter players other than QB, RB, WR, TE or K
  //     onSelectPosition(["QB", "RB", "WR", "TE", "K"]);
  //   } else {
  //     onSelectPosition(position); // Render players of currently selected position
  //   }
  // };
  const handleButtonClick = (index, position) => {
    scrollToTop();
    onSelectPosition(position); // Render players of the current selected position
  };

  return (
    <>
      <Grid container spacing={0} alignItems="center" justifyContent="center">
        {positionsFilters.map((position, index) => (
          <Grid key={index} p={0.2}>
            <Button
              key={index}
              variant="contained"
              color={currentSelectedIndex === index ? "primary" : "inherit"}
              onClick={() => handleButtonClick(index, position)}
              className={styles.positionButtonHover}
              style={{ borderRadius: "5px", padding: "0px 2px", minWidth: "20px", width: "56.4px" }}
            >
              {position}
            </Button>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
